import { Seo } from "../components/layout/Seo";
import { PageHero } from "../components/layout/PageHero";
import { ContactSection } from "../components/home/ContactSection";

export default function ContactPage() {
  return (
    <>
      <Seo title="Request a Quote or Site Survey | TechCare Technologies" path="/contact"
        description="Request a quote, book a site survey or send a general enquiry to TechCare Technologies. Every request receives a unique reference number." />
      <PageHero eyebrow="Contact" lines={["You take care of business.", <span key="w" className="tc-copper-text">We take care of the tech.</span>]} testid="contact-hero"
        lead="Tell us about your project, your site or your question. We'll review it and get back to you." />
      <ContactSection id="contact-form" eyebrow="Start here" />
    </>
  );
}
